import React,{useState,useEffect} from "react";
import "./tags.css"
import { TagsInput } from "react-tag-input-component";

function InputTags({ getTags,selected}) {
  const [select, setSelected] = useState([]);
  useEffect(() => {
    setSelected(selected)
  },[selected])
  return (
    <React.Fragment>
      <TagsInput
        value={selected && selected}
        onChange={getTags}
        // seprators={selected}
        name="tags"
        placeHolder="Enter tags"
        onExisting={() => alert("value already there")}
      />
    </React.Fragment>
  );
}

export default InputTags;
